import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useState } from "react";
import { MPR_TOOLS } from "../../../../../constants/Constants";
import { CrosshairsTool, WindowLevelTool } from "@cornerstonejs/tools";
import GetToolSVG from "./GetToolSVG";
import { useTranslation } from "react-i18next";
import MPRTool from "./MPRTool";
const toolBarFlex = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const MPRToolbar = () => {
  const { t } = useTranslation();
  const [hovered, setHovered] = useState(false);
  const handleMouseOver = () => {
    console.log("Handle Mouse over");
    setHovered(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
    // <div
    //   style={{
    //     height: "100%",
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //   }}
    // >
    <>
      {MPR_TOOLS.map((tool, index) => {
        return (
          <div key={index} style={{ ...toolBarFlex, height: "100%" }}>
            <MPRTool tool={tool} />
          </div>
        );
      })}
    </>

    /* <TooltipHost
        delay={TooltipDelay.zero}
        id={MPR_TOOLS["window-level-tool"]}
        directionalHint={DirectionalHint.bottom}
        styles={toolTipStyles}
        content={t(MPR_TOOLS["window-level-tool"])}
      >
        <div
        //   onClick={() => toggleMPR(tool.key)}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          style={toolStyle}
          aria-describedby={MPR_TOOLS["window-level-tool"]}
        >
          <GetToolSVG toolName={WindowLevelTool.toolName} hovered={hovered} />
        </div>
      </TooltipHost>
      <TooltipHost
        delay={TooltipDelay.zero}
        id={MPR_TOOLS["crosshairs"]}
        directionalHint={DirectionalHint.bottom}
        styles={toolTipStyles}
        content={t(MPR_TOOLS["crosshairs"])}
      >
        <div
        //   onClick={() => toggleMPR(tool.key)}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          style={toolStyle}
          aria-describedby={MPR_TOOLS["crosshairs"]}
        >
          <GetToolSVG toolName={CrosshairsTool.toolName} hovered={hovered} />
        </div>
      </TooltipHost>
      <TooltipHost
        delay={TooltipDelay.zero}
        id={"EXITMPR"}
        directionalHint={DirectionalHint.bottom}
        styles={toolTipStyles}
        content={t("viewer.tools.exit-mpr")}
      >
        <div
        //   onClick={() => toggleMPR(tool.key)}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseLeave}
          style={toolStyle}
          aria-describedby={"EXITMPR"}
        >
          <GetToolSVG toolName={"EXITMPR"} hovered={hovered} />
        </div>
      </TooltipHost> */
    // </div>
  );
};

export default MPRToolbar;
